import { memo, useEffect } from "react";
import styled from "styled-components";
import MyProjectsList from "./MyProjects/MyProjectsList";
import SharedACProjectList from "./SharedProjects/SharedACProjectList";
import { useAtom } from 'jotai';
import { userACRoles } from "~/stores/UserStore";
import AllProjects from "./AllProjects/AllProjects";
import { AC_TLGeo_Role } from "~/common/typescript/services/access_control/AC_Tlgeo";
import { UI_ScreenStyles } from "../UI_ScreenStyles";
import { createBreadcrumbItems, commonBreadcrumbs } from "~/utils/breadcrumbUtils";
import { useSearchParams, useNavigate } from "react-router-dom";

const ProjectListScreen = () => {
  const [roles] = useAtom(userACRoles);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const action = searchParams.get('action');
  const mapDataId = searchParams.get('map_data_id');

  useEffect(() => {
    if (action || mapDataId) {
      navigate(`/action?${searchParams.toString()}`, { replace: true });
    }
  }, [action, mapDataId, searchParams, navigate]);

  if (action || mapDataId) {
    return null;
  }

  return (
    <UI_ScreenStyles.UI_Wrapper>
      <UI_ScreenStyles.UI_Breadcrumb
        items={createBreadcrumbItems([
          commonBreadcrumbs.home,
          { title: 'Dự án', icon: commonBreadcrumbs.projects.icon }
        ])}
      />

      <UI_ScreenStyles.UI_Content_Wrapper>
        <div>
          <MyProjectsList />
        </div>

        <div style={{ marginTop: 20 }}>
          <SharedACProjectList />
        </div>

        {
          roles.includes(AC_TLGeo_Role.TLGEO_ADMIN) && (
            <div style={{ marginTop: 20 }}>
              <AllProjects />
            </div>
          )
        }
      </UI_ScreenStyles.UI_Content_Wrapper>
    </UI_ScreenStyles.UI_Wrapper>
  );
}

export default memo(ProjectListScreen);